import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setPreload } from "../../server/CartsOpen";
import Input from "../containers/InputForm";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { UpdateCustomerStationId } from "../../server/Customer";

const schema = yup
  .object({
    Name: yup
      .string()
      .required("חובה להכניס שם")
      .matches(/^[\u0590-\u05FFa-zA-Z\s]+$/, "שם חייב להכיל אותיות בלבד"),
    StreetName: yup
      .string()
      .required("חובה להכניס שם רחוב")
      .matches(/^[\u0590-\u05FFa-zA-Z0-9\s]+$/, "שם רחוב לא תקין"),
    StreetNumber: yup
      .string()
      .required("חובה להכניס מס' בניין")
      .matches(/^\d+$/, "מספר בניין חייב להכיל ספרות בלבד"),
    HouseNumber: yup
      .string()
      .required("חובה להכניס מס' דירה")
      .matches(/^\d+$/, "מספר דירה חייב להכיל ספרות בלבד"),
    Floor: yup
      .string()
      .required("חובה להכניס קומה")
      .matches(/^-?\d+$/, "קומה חייבת להכיל ספרות בלבד"),
    ZipCode: yup.string().matches(/^\d*$/, "מיקוד חייב להכיל ספרות בלבד"),
  })
  .required();

const NewAddress = ({ pushAddress, setNewAddress, closeSignUpPopup }) => {
  const dispatch = useDispatch();
  const { user, stationId } = useSelector((state) => ({
    user: state.user.user,
    stationId: state.user.stationId,
  }));

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      Name: user?.lastName || "",
    },
  });

  const [checkBox, setCheckBox] = useState(true);

  useEffect(() => {
    if (user?.lastName) {
      setValue("Name", user.lastName);
    }
  }, [user, setValue]);

  const saveAddress = async (data) => {
    dispatch(setPreload(true));

    const addressToUpdate = {
      streetName: data.StreetName,
      houseNumber: data.StreetNumber,
      apartment: data.HouseNumber,
      zipCode: data.ZipCode,
      name: data.Name,
      floor: data.Floor,
    };

    try {
      await pushAddress(addressToUpdate);
      if (typeof closeSignUpPopup === "function") {
        closeSignUpPopup();
      } else {
        setNewAddress(false);
      }
    } catch (e) {
      console.error("Error saving address:", e);
    } finally {
      dispatch(setPreload(false));
    }
  };

  return (
    <div className="add-address">
      <span className="note">שדות חובה מסומנים ב*</span>
      <form className="register" onSubmit={handleSubmit(saveAddress)}>
        {/* שדה רחוב - עכשיו אינפוט רגיל */}
        <span className="details-address">
          <span className="name" style={{ width: "100%" }}>
            <Input
              type="text"
              register={register}
              label="רחוב ועיר*"
              errors={errors}
              name="StreetName"
            />
          </span>
        </span>

        <span className="details-address">
          <span className="name">
            <Input
              type="text"
              register={register}
              label="שם מקום האספקה"
              errors={errors}
              name="Name"
            />
          </span>

          <span className="sub-details">
            <Input
              type="tel"
              register={register}
              label="מס' בניין*"
              errors={errors}
              name="StreetNumber"
            />
            <Input
              type="tel"
              register={register}
              label="קומה*"
              errors={errors}
              name="Floor"
            />
            <Input
              type="tel"
              register={register}
              label="מס' דירה*"
              errors={errors}
              name="HouseNumber"
            />
          </span>
        </span>

        <span className="note-shipping">
          <Input
            type="tel"
            register={register}
            label="מיקוד"
            errors={errors}
            name="ZipCode"
          />
        </span>
        <span className="checkbox-and-btn">
          <button className="btn" type="submit">
            {"שמור > "}
          </button>
        </span>
      </form>
    </div>
  );
};

export default NewAddress;
